<template>
    <div>
        <Steps :current-page="5"></Steps>
        <div class="container container-medium">
            <div class="text-center heading-wrapper">
                <span class="heading">{{ $t('btn_choose_payment_method') }}</span>
            </div>
            <div class="purchase-wrapper">
                <div class="text-center">
                    <span class="main-text">{{ $t('order_step5') }}</span>
                </div>
            </div>
        </div>
        <div class="container container-xs mt-4" v-if="selectedProfile">
            <p><strong>{{ $t('label_billing_type') }}:</strong></p>
            <template v-if="selectedProfile.billing_type == 'pf'">
                <span><strong>{{ $t('type') }}</strong>: {{ $t('individual_person') }}</span><br/>
                <span v-if="selectedProfile.last_name || selectedProfile.first_name"><strong>{{ $t('label_first_name') }}</strong>: {{selectedProfile.last_name}} {{selectedProfile.first_name}}</span><br/>
                <span v-if="selectedProfile.fiscal_or_address"><strong>{{ $t('label_address') }}</strong>: {{selectedProfile.fiscal_or_address}}</span>
            </template>
            <template v-if="selectedProfile.billing_type == 'pj'">
                <span><strong>{{ $t('type') }}</strong>: {{ $t('juridical_person') }}</span><br/>
                <span v-if="selectedProfile.company"><strong>{{ $t('label_company_name') }}</strong>: {{selectedProfile.company}}</span><br/>
                <span v-if="selectedProfile.fiscal_code"><strong>{{ $t('label_cui') }}</strong>: {{selectedProfile.fiscal_code}}</span><br/>
                <span v-if="selectedProfile.j_code"><strong>{{ $t('label_reg_com') }}</strong>: {{selectedProfile.j_code}}</span>
            </template>
        </div>
        <template v-if="!loading">
            <div class="container container-xs">
                <Alerts :alert-type="alertType" :alert-color="'danger'"></Alerts>
                <div class="text-left my-4"
                    v-for="(item, key) in availablePaymentMethods()"
                    :key="key"
                    v-if="
                        (item.id != 8 && item.id != 10) || 
                        (item.id == 8 && hasCreditInstantActivated) || 
                        (item.id == 10 && hasInstantDebitActivated)"
                    :class="[{
                        'card-primary': method == item.id, 
                        'bg-danger text-white': (
                            (item.id == 8 && !instantCreditAvailableAmount()) || 
                            (item.id == 10 && !instantDebitAvailableAmount()) || 
                            (item.id == 1 && !checkIfAllowedOP())
                        )}]"
                    @click="chooseMethod(item.id)">
                    <div class="paymentMethod" :class="{'selected': method == item.id}">
                        <div class="elipse-complete position-absolute margin-minus" v-if="method == item.id">
                            <div class="icon v-icon"></div>
                        </div>
                        <strong class="payment-name">{{item.name}}</strong>
                        <p v-if="item.id == 1 && !checkIfAllowedOP()">{{ opErrorMsg }}</p>
                        <span v-if="item.id == 8 && !instantCreditAvailableAmount()"> - {{ $t('payment_method_insuficient_credit') }}</span>
                        <span v-if="item.id == 10 && !instantDebitAvailableAmount()"> - {{ $t('payment_method_insuficient_debit') }}</span>
                        <span class="amount" :class="[{'text-white': item.id == 8 && !instantCreditAvailableAmount()}]">
                            <p class="m-0 reading">{{item.description}}</p>
                            <template v-if="item.id == 1 && item.id == method">
                                <div class="p-3 reading">
                                    <span><strong>{{ $t('warning') }}</strong> {{ $t('warning_txt_1') }}</span><br/>
                                    <span>{{ $t('warning_txt_2') }}</span><br/><br/>
                                    <span><strong>{{ $t('warning') }}</strong> {{ $t('warning_txt_3') }}</span><br/><br/>
                                    <span>{{ $t('warning_txt_4') }}</span>
                                </div>
                            </template>
                        </span>
                        <div class="mt-3" v-show="item.id == 7 && method == item.id">
                            <div class="d-flex" id="itranfer">
                                <div class="d-flex align-items-center" v-on:click="chooseiTransferBank('ITRANSFER_BT')" v-if="!disabledPaymentMethods.includes('BT')">
                                    <input type="radio" v-model="iTransfer" value="ITRANSFER_BT">
                                    <img src="../../assets/media/bt.png" alt="BT">
                                </div>
                                <div class="d-flex align-items-center ml-4" v-on:click="chooseiTransferBank('ITRANSFER_BCR')" v-if="!disabledPaymentMethods.includes('BCR')">
                                    <input type="radio" v-model="iTransfer" value="ITRANSFER_BCR">
                                    <img src="../../assets/media/bcr.png" alt="BCR">
                                </div>
                            </div>
                        </div>
                        <div class="reading" v-if="$store.getters['auth/getLoginStatus'] && item.id == 8 && hasCreditInstantActivated">
                            <template v-if="selectedProfile.has_instant_credit">
                                <br/>
                                <span class="amount" :class="[{'text-white': item.id == 8 && !instantCreditAvailableAmount()}]">
                                    {{ $t('payment_method_credit_erv') }}: {{selectedProfile.instant_limit_amount.toFixed(2)}} {{ $tc('currency', selectedProfile.instant_limit_amount) }}
                                </span>
                            </template>
                            <template v-if="selectedProfile.has_instant_credit_tpf">
                                <br/>
                                <span class="amount" :class="[{'text-white': item.id == 8 && !instantCreditAvailableAmount()}]">
                                    {{ $t('payment_method_credit_tpf') }}: {{selectedProfile.instant_limit_tpf_amount.toFixed(2)}} {{ $tc('currency', selectedProfile.instant_limit_tpf_amount) }}
                                </span>
                            </template>
                        </div>
                        <div class="reading" v-if="$store.getters['auth/getLoginStatus'] && item.id == 10 && hasInstantDebitActivated">
                            <template v-if="selectedProfile.has_instant_debit">
                                <br/>
                                <span class="amount" :class="[{'text-white': item.id == 10 && !instantDebitAvailableAmount()}]">
                                    {{ $t('payment_method_debit_erv') }}: {{selectedProfile.instant_debit_limit_amount.toFixed(2)}} {{ $tc('currency', selectedProfile.instant_debit_limit_amount) }}
                                </span>
                            </template>
                            <template v-if="selectedProfile.has_instant_debit_tpf">
                                <br/>
                                <span class="amount" :class="[{'text-white': item.id == 10 && !instantDebitAvailableAmount()}]">
                                    {{ $t('payment_method_debit_tpf') }}: {{selectedProfile.instant_debit_limit_tpf_amount.toFixed(2)}} {{ $tc('currency', selectedProfile.instant_debit_limit_tpf_amount) }}
                                </span>
                            </template>
                        </div>
                        <div class="mt-3 tokens" v-if="item.id == 2 && loginStatus && method == item.id">
                            <template v-if="tokens != null && tokens.length">
                                <div class="mb-3">{{ $t('payment_method_credit_erv') }}:</div>
                                <div class="form-group mb-0" :key="key" v-for="(t, key) in tokens">
                                    <label class="pointer">
                                        <input type="radio" :value="t.id" v-model="tokenId">
                                        <span class="ml-2 mr-2">
                                            <img src="../../media/mastercard.svg" v-if="t.cardType == 'Mastercard'">
                                            <img src="../../media/visa.png" v-if="t.cardType == 'Visa'">
                                        </span>
                                        {{t.cardNumberMask}}
                                    </label>
                                </div>
                            </template>
                            <div class="form-group mb-0">
                                <label class="pointer">
                                    <input type="radio" :value="null" v-model="tokenId">
                                    <span class="ml-3 reading">{{ $t('new_card') }}</span>
                                </label>
                            </div>
                            <div class="form-group mb-0" v-if="tokenId == null">
                                <label class="pointer">
                                    <input type="checkbox" :value="true" v-model="saveCard">
                                    <span class="ml-3 reading">
                                        {{ $t('add_card_for_next_transactions') }}
                                    </span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <span class="invalid-feedback" v-if="errorMsgs.acceptancePayment && !acceptancePayment">
                    {{errorMsgs.acceptancePayment}}
                </span>
                <div class="form-group form-check">
                    <input type="checkbox" class="form-check-input" name="acceptancePayment" id="acceptancePayment" v-model="acceptancePayment">
                    <label class='accept-terms ml-2' for="acceptancePayment">
                        {{ $t('payment_method_terms') }}
                        <a class="link reading" @click.stop.prevent="openModal('termsModal')">
                            {{ $t('new_account_tc') }}
                        </a>
                        {{ $t('and') }}
                        <a class="link" @click.stop.prevent="openModal('confidentialityModal')">
                            {{ $t('new_account_pc') }}
                        </a>
                    </label>
                </div>

                <div id="recaptcha-error" class="alert alert-danger text-center" v-if="recaptchaError != null">
                    {{ recaptchaError }}
                </div>
                <div id="recaptcha-container"></div>

                <div>
                    <PaymentMethodButtons v-on:placeOrder="placeOrder" :valid-terms="acceptancePayment == true"></PaymentMethodButtons>
                </div>
            </div>
        </template>

        <div class="modal" id="termsModal" tabindex="-1">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{$t('terms')}}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <div class="icon icon-x"></div>
                        </button>
                    </div>
                    <div class="modal-body px-0">
                        <terms :in-modal="true"></terms>
                    </div>
                    <div class="modal-footer">
                        <div class="d-flex justify-content-end">
                            <button type="button" class="main-btn" @click="f_agreeTC()">
                                {{ $t('btn_i_understand') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" id="confidentialityModal" tabindex="-1">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{$t('new_account_pc')}}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <div class="icon icon-x"></div>
                        </button>
                    </div>
                    <div class="modal-body px-0">
                        <confidentiality :in-modal="true"></confidentiality>
                    </div>
                    <div class="modal-footer">
                        <div class="d-flex justify-content-end">
                            <button type="button" class="main-btn" @click="f_agreePC()">
                                {{ $t('btn_i_understand') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
     </div>
</template>

<script>

import PaymentMethodButtons from './PaymentMethodButtons.vue'
import { mapGetters, mapActions, mapState } from 'vuex'
import TCPCModal from '../snippets/TCPCModal.vue'
import Steps from '../snippets/Steps.vue'
import Alerts from '../snippets/Alerts.vue'
import loadRecaptcha from '../mixins/loadRecaptcha'

export default {
    name: 'PaymentMethod',
    mixins: [
        TCPCModal,
        loadRecaptcha
    ],
    components: {
        PaymentMethodButtons,
        Steps,
        Alerts
    },
    props: {
    },
    data: function() {
        return {
            method: 2,
            iTransfer: null,
            selected: false,
            acceptancePayment: false,
            errorMsgs: {
                acceptancePayment: '',
            },
            loading: false,
            hideOP: false,
            paymentMethods: [
                {
                    id: 2,
                    name: this.$t('payment_method_credit_card'),
                    description: this.$t('payment_method_credit_card_description')
                },
                {
                    id: 8,
                    name: this.$t('payment_method_instant_credit'),
                    description: this.$t('payment_method_instant_credit_description')
                },
                {
                    id: 7,
                    name: 'iTransfer',
                    description: this.$t('payment_method_iTransfer_description')
                },
                {
                    id: 1,
                    name: this.$t('payment_method_payment_order'),
                    description: this.$t('payment_method_payment_order_description')
                },
                {
                    id: 10,
                    name: this.$t('payment_method_instant_debit'),
                    description: this.$t('payment_method_instant_debit_description')
                }
            ],
            opErrorMsg: null,
            alertType: 'alert_paymentMethods',
            recaptchaError: null,
            validTerms: false
        }
    },
    computed: {
        ...mapState('user', [
            'user'
        ]),

        ...mapState('cart', [
            'orderDetails',
        ]),

        ...mapState('profiles', [
            'profiles',
            'tmpProfile'
        ]),

        ...mapGetters('cart', [
            'cartCount',
            'cartTotal',
            'cartTollTotal',
            'cartVignetteTotal',
            'getCart'
        ]),

        ...mapGetters({
            tokens: 'payuTokens/getTokens',
            loginStatus: 'auth/getLoginStatus',
            getSaveCard: 'payuTokens/getSaveCard',
            getTokenId: 'payuTokens/getTokenId',
            disabledPaymentMethods: 'settings/getDisabledPaymentMethods'
        }),

        saveCard: {
            set(value) {
                return this.setSaveCard(value);
            },
            get() {
                return this.getSaveCard;
            }
        },

        tokenId: {
            set(value) {
                return this.setTokenId(value);
            },
            get() {
                return this.getTokenId;
            }
        },

        hasCreditInstantActivated() {
            if(!this.profiles) {
                return false;
            }

            let profile = this.profiles.filter(profile => profile.id == this.orderDetails.profile_id)[0];

            if(this.orderType == 'mixed' && profile.has_instant_credit && profile.has_instant_credit_tpf) {
                return true;
            }

            if(this.orderType == 'erv' && profile.has_instant_credit) {
                return true;
            }

            if(this.orderType == 'tpf' && profile.has_instant_credit_tpf) {
                return true;
            }


            return false;
        },

        hasInstantDebitActivated() {
            if(!this.profiles) {
                return false;
            }

            let profile = this.profiles.filter(profile => profile.id == this.orderDetails.profile_id)[0];

            if(this.orderType == 'mixed' && profile.has_instant_debit && profile.has_instant_debit_tpf) {
                return true;
            }

            if(this.orderType == 'erv' && profile.has_instant_debit) {
                return true;
            }

            if(this.orderType == 'tpf' && profile.has_instant_debit_tpf) {
                return true;
            }

            return false;
        },

        //returns: mixed, erv, tpf
        orderType() {
            let counter = {
                'vignette': 0,
                'toll': 0
            };

            for(let i = 0; i < this.getCart.length; i++) {
                counter[this.getCart[i].type]++;
            }

            if(counter['vignette'] && counter['toll']) {
                return 'mixed';
            }
            else if(counter['vignette']) {
                return 'erv';
            }
            else {
                return 'tpf';
            }
        },
        selectedProfile() {
            if(this.profiles) {
                return this.profiles.filter(profile => profile.id == this.orderDetails.profile_id)[0];
            }

            return null;
        }
    },
    mounted() {
        if(!this.cartCount) {
            this.$router.push({name: 'homepage'});
        }
        else {
            if(!this.orderDetails.profile_id && !this.tmpProfile) {
                this.$router.push({name: 'billing'});
            }
        }

        if(!this.profiles && this.$store.getters['auth/getLoginStatus']) {
            this.getProfiles();
        }

        this.chooseMethod(this.method);

        if(this.loginStatus) {
            this.refreshUserAction();
            this.getPayuTokens();
        }

        // this.initPushNotification(document, 'script');

        this.checkIfOPIsPossible();
    },
    methods: {

        ...mapActions('user', {
            refreshUserAction: 'refreshUser'
        }),

        ...mapActions('cart', {
            placeOrderAction: 'placeOrder',
            changeMethodAction: 'changeMethod',
            saveMOIDAction: 'saveMOID',
            saveMOHashAction: 'saveMOHash',
            saveCartAction: 'saveCart',
            saveCartErrorsAction: 'saveCartErrors',
            changeiTransferAction: 'changeiTransfer',
            setProfileSubscriberId: 'setProfileSubscriberId',
            resetCartAction: 'resetCart',
            savePreviousOrderDetailsForAnalytics: 'savePreviousOrderDetailsForAnalytics'
        }),

        ...mapActions('profiles', [
            'getProfiles',
        ]),

        ...mapActions({
            getPayuTokens: 'payuTokens/getPayuTokens',
            setTokenId: 'payuTokens/setTokenId',
            setSaveCard: 'payuTokens/setSaveCard'
        }),

        instantCreditAvailableAmount() {
            if(this.profiles == null) {
                return false;
            }
            
            let profile = this.profiles.filter(profile => profile.id == this.orderDetails.profile_id)[0];

            if(!this.$store.getters['auth/getLoginStatus']) {
                return false;
            }

            if(this.cartVignetteTotal) {
                if(!profile.has_instant_credit || (this.cartVignetteTotal > profile.instant_limit_amount)) {
                    return false;
                }
            }

            if(this.cartTollTotal) {
                if(!profile.has_instant_credit_tpf || (this.cartTollTotal > profile.instant_limit_tpf_amount)) {
                    return false;
                }
            }

            return true;
        },

        instantDebitAvailableAmount() {
            if(this.profiles == null) {
                return false;
            }
            
            let profile = this.profiles.filter(profile => profile.id == this.orderDetails.profile_id)[0];

            if(!this.$store.getters['auth/getLoginStatus']) {
                return false;
            }

            if(this.cartVignetteTotal) {
                if(!profile.has_instant_debit || (this.cartVignetteTotal > profile.instant_debit_limit_amount)) {
                    return false;
                }
            }

            if(this.cartTollTotal) {
                if(!profile.has_instant_debit_tpf || (this.cartTollTotal > profile.instant_debit_limit_tpf_amount)) {
                    return false;
                }
            }

            return true;
        },

        chooseMethod(value) {
            this.selected = true;
            if(value == 8 && !this.instantCreditAvailableAmount()) {
                return false;
            }

            if(value == 10 && !this.instantDebitAvailableAmount()) {
                return false;
            }

            if(value == 1 && !this.checkIfAllowedOP()) {
                return false;
            }

            if(this.saveCard) {
                this.saveCard = false;
            }

            this.method = value;
            this.changeMethodAction(value);
        },

        chooseiTransferBank(value) {
            this.iTransfer = value;
            this.changeiTransferAction(value);
        },

        availablePaymentMethods() 
        {
            let tmp = [];
            let finalPaymentMethods = this.paymentMethods;
            
            let disablePayments = [];
            let alert = this.getAlertByType(this.alertType);
            if(alert) {
                if(alert['extra']['disableCardPayment'] === "1") {
                    disablePayments.push(2);
                }

                if(alert['extra']['disableInstantCredit'] === "1") {
                    disablePayments.push(8);
                }

                if(alert['extra']['disableOP'] === "1") {
                    disablePayments.push(1);
                }

                if(alert['extra']['disableiTransfer'] === "1") {
                    disablePayments.push(7);
                }
            }

            if(this.disabledPaymentMethods != null) {
                this.disabledPaymentMethods.map(method => {
                    if(!['BCR', 'BT'].includes(method)) {
                        if(!disablePayments.includes(parseInt(method))) {
                            disablePayments.push(parseInt(method));
                        }
                    }
                });
            }

            finalPaymentMethods = this.paymentMethods.filter(item => !disablePayments.includes(item.id))

            if(this.$store.getters['auth/getLoginStatus']) {

                if(this.hideOP) {
                    tmp = finalPaymentMethods.filter(item => item.id != 1);
                }
                else {
                    tmp = finalPaymentMethods;
                }

            }
            else {
                //excluding instant credit as I'm not logged in
                tmp = finalPaymentMethods.filter(item => ![8].includes(item.id));
            }
            
            return tmp;
        },

        async placeOrder() {
            this.recaptchaError = null;

            await this.checkRecaptcha();

            var ok = true;
            if(!this.acceptancePayment) {
                ok = false;
                this.errorMsgs.acceptancePayment = this.$t('new_account_must_accept_tc');
            }

            if (ok) {

                try {
                    this.loading = true;
                    let response = await this.placeOrderAction();

                    this.savePreviousOrderDetailsForAnalytics({
                        order_id: response.data.order.id,
                        value: this.cartTotal
                    });
                    this.resetCartAction();

                    if(this.method == 2 || this.method == 7) {
                        let url = process.env.VUE_APP_API_URL + '/orders/pay/' + response.data.order.hash;
                        if(this.method == 7 && this.iTransfer) {
                            url += '/' + this.iTransfer;
                        }
                        
                        let inAppRef = this.openUrl(url, false, 'no');
                        if(window.cordova && ['android', 'ios'].includes(window.cordova.platformId)) {
                            inAppRef.addEventListener('loadstart', (event) => {
                                if(this.isSuccessfullPayment(event.url)) {
                                    inAppRef.close();
                                    this.$router.push({name : "thank-you"});
                                }
                            });
                        }
                    }
                    else {
                        this.$router.push({name : "thank-you"});
                    }
                }
                catch(err) {
                    this.loading = false;
                    
                    if(err?.response?.data?.error?.error_code == 'recaptcha') {
                        this.tryWithCaptchaVersion('v2');
                        this.loadRecaptchaV2();
                        this.recaptchaError = err.response.data.error.error_msg;
                        
                        this.$nextTick(() => {
                            let topScroll = document.getElementById('recaptcha-error').getBoundingClientRect().top - 150 + window.scrollY;
                            window.scroll({
                                top: topScroll, 
                                left: 0, 
                                behavior: 'smooth' 
                            });
                        });

                        return;
                    }

                    this.$dialog.alert({
                        'message': err.response.data.error.error_msg,
                        'confirmButtonText': this.$t('btn_i_understand')
                    });

                    if(err?.response?.data?.error?.data != void 0 && Object.keys(err?.response?.data?.error?.data).length) {

                        if(err.response.data.error.data.mo_id != 'undefined') {
                            this.saveMOIDAction(err.response.data.error.data.mo_id);
                        }

                        if(err.response.data.error.data.mo_hash != 'undefined') {
                            this.saveMOHashAction(err.response.data.error.data.mo_hash);
                        }

                        if("cart" in err.response.data.error.data) {
                            this.saveCartAction(err.response.data.error.data.cart);
                        }

                        if("cart_with_errors" in err.response.data.error.data && err.response.data.error.data.cart_with_errors.length) {
                            this.saveCartErrorsAction(err.response.data.error.data.cart_with_errors);

                            this.$router.push({name : "cart"});
                        }
                    }
                }
            }
        },

        initPushNotification(d, t) {
            if(document.getElementById('pushalert') != null) {
                return;
            }

            var g = d.createElement(t),
            s = d.getElementsByTagName(t)[0];
            g.id = 'pushalert';
            g.src = "https://cdn.pushalert.co/integrate_3684aa8f61331387f780b098b8bbd274.js";
            g.onload = this.onPushAlertLoad;
            s.parentNode.insertBefore(g, s);
        },

        onPushAlertLoad() {
            (pushalertbyiw = window.pushalertbyiw || []).push(['onSuccess', (result) => {
                this.setUserSubscriberID(result.subscriber_id);
            }]);

            (pushalertbyiw = window.pushalertbyiw || []).push(['onReady', () => {
                this.setUserSubscriberID(PushAlertCo.subs_id);
            }]);
        },

        setUserSubscriberID(id) {
            if(id) {
                //set the user's subscriber_id
                this.setProfileSubscriberId(id);
            }
        },

        checkIfPeajProductsInCart() {
            for(let i = 0; i < this.getCart.length; i++) {
                if(this.getCart[i].type == 'toll') {
                    return true;
                }
            }

            return false;
        },

        checkIfOPIsPossible() {
            for(let i = 0; i < this.getCart.length; i++) {
                if(this.isToday(this.getDateObject(this.getCart[i].fromDate)) && this.getCart[i].type == 'vignette') {
                    this.hideOP = true;
                    return false;
                }
            }
        },

        checkIfProductsInFutureAndNotWeekend() {
            for(let i = 0; i < this.getCart.length; i++) {
                if(!this.isDateInFutureNotWeekend(this.getDateObject(this.getCart[i].fromDate)) && this.getCart[i].type == 'vignette') {
                    return false;
                }
            }

            return true;
        },

        checkIfAllowedOP() {
            let date = new Date();
            let day = date.getDay();
            let hour = date.getHours();
            let minutes = date.getMinutes();

            let ret = true;

            if([0, 5, 6].includes(day) || (day == 4 && hour >= 16 && minutes >= 30)) {
                this.opErrorMsg = this.$t('payment_method_op_not_available_during_weekend');
                ret = false;
            }

            if(this.isLastDay() && ret) {
                this.opErrorMsg = this.$t('payment_method_op_not_available_last_day_of_month');
                ret = false;
            }

            if(!ret && !this.checkIfPeajProductsInCart()) {
                if(this.checkIfProductsInFutureAndNotWeekend()) {
                    ret = true;
                    this.opErrorMsg = null;
                }
            }

            return ret;
        },

        isLastDay() {
            var test = new Date();
            var month = test.getMonth();

            test.setDate(test.getDate() + 1);
            return test.getMonth() !== month;
        },

        isSuccessfullPayment(url) {
            if(url.includes('/multumim')) {
                return true;
            }

            return false;
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import '../../assets/scss/_variables';

    #termsModal, #confidentialityModal {
        ::v-deep {
            .default-page-paddings {
                padding-top: 0px;

                .container {
                    padding: 0px;
                }

                .default-content {
                    padding-top: 15px;
                }
            }
        }
    }

    .accept-terms {

        font-weight: 500;

        a {

            font-weight: 500;
        }
    }

    .heading-wrapper {
        margin-top: 30px;

        .heading {
            color: $black;
        }
    }

    .paymentMethod {
        background: transparent;
        height: 100%;
        border-radius: 4px;
        border: 1px solid #0F2443;
        padding: 20px 20px;
        position: relative;
        display: block;

        &.selected {
            padding: 18px 18px;
            border: 3px solid #0F2443;
        }

        .elipse-complete {
            top: -15px;
            right: -15px;
        }
        &:hover {
            cursor: pointer;
        }
    }
    .amount {
        line-height: 18px;
        font-size: 12px;
    }

    .main-text {
        font-weight: bold;

        font-size: 22px;
    }

    .header-1 {
        margin-top: 87px;
    }

    .modal-content {
        .modal-header {
            h5 {
                font-size: 34px;

                font-weight: bold;
            }
        }
    }

    .link {
        padding: 0px;
    }

    #acceptancePayment {
        height: 40%;
        width: 20px;

        @media only screen and (min-width: 769px) {
            margin-top: 4px;
        }

        @media only screen and (max-width: 768px) {
            margin-top: 0px;
        }
    }

    .purchase-wrapper {
        margin-top: 14px;
    }

    .tokens {
        label {
            font-size: 14px;
        }
    }

    .payment-name {
        font-size: 22px;
    }

</style>
